import { render, staticRenderFns } from "./Investor_list.vue?vue&type=template&id=5aaffa30&scoped=true&"
import script from "./Investor_list.vue?vue&type=script&lang=js&"
export * from "./Investor_list.vue?vue&type=script&lang=js&"
import style0 from "./Investor_list.vue?vue&type=style&index=0&id=5aaffa30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaffa30",
  null
  
)

export default component.exports